export const GenderTypes = Object.freeze({
  MALE: 'male',
  FEMALE: 'female'
});



// WEBPACK FOOTER //
// ./src/enums/GenderTypes.js